import { HikvisionCameraDirectionEnum } from '@zaoblako/shared/modules/cctv/enums/hikvision-camera-direction.enum';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link HikvisionCameraDirectionEnum} enumeration values */
export const HikvisionCameraDirectionEnumI18n: EnumI18nInterface<HikvisionCameraDirectionEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [HikvisionCameraDirectionEnum.ENTRY]: 'Въезд',
    [HikvisionCameraDirectionEnum.EXIT]: 'Выезд',
  },
  [I18nLocalesEnum.EN_US]: {
    [HikvisionCameraDirectionEnum.ENTRY]: 'Entry',
    [HikvisionCameraDirectionEnum.EXIT]: 'Exit',
  },
};
